module.exports = __webpack_public_path__ + "img/blog.d031e25d.jpg";